import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';

import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import combineStyles from '../../../utils/combineStyles';
import classnames from 'classnames';

import SpacingStyles from './../../../styles/helpers/spacing';
import { formatComment } from './helpers';
import CommentString from './CommentString';
import CommentHeader from './CommentHeader';
import { AppContext } from '../../../AppProvider';
import { isPermissible } from '../../Global/PermissionResolver';
import { ADMIN } from '../../../constants/permissions';
import { MAX_COMMENT_CHAR } from './../../../constants/constants';

const styles = theme => ({
  commentContents: {
    marginTop: theme.spacing.unit * 2
  },
  commentRow: {
    padding: theme.spacing.unit * 3,
    borderBottom: '1px solid #E6E8E9'
  },
  readMore: {
    cursor: 'pointer',
    color: '#00A1FB',
    textDecoration: 'underline'
  }
});

export class CommentItem extends PureComponent {
  static propTypes = {
    comment: PropTypes.object.isRequired,
    users: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired,
    onViewSingleComment: PropTypes.func,
    onEditClick: PropTypes.func.isRequired
  };
  state = {
    displayEditModal: false
  };

  render() {
    const {
      classes,
      comment: {
        changedUtc,
        createdByUser: { firstName, lastName },
        createdByUserId,
        content
      },
      users,
      onDelete,
      onViewSingleComment,
      onEditClick,
      t
    } = this.props;
    const { user } = this.context.globalProps;
    const isAdmin = isPermissible(this.context.globalProps, ADMIN, true);
    const editable =
      isAdmin || createdByUserId.toString() === user.id.toString();
    const truncateComment = content.length > MAX_COMMENT_CHAR ? true : false;
    const contentString =
      truncateComment && onViewSingleComment
        ? content.substring(0, MAX_COMMENT_CHAR)
        : content;
    const parsedCommentText = formatComment(contentString);
    return (
      <Fragment>
        <div className={classes.commentRow}>
          <CommentHeader
            inEditMode={false}
            firstName={firstName}
            lastName={lastName}
            changedUtc={changedUtc}
            onDelete={onDelete}
            onEditClick={onEditClick}
            comment={this.props.comment}
            users={users}
            isAdmin={isAdmin}
            editable={editable}
            deletable={isAdmin}
          />
          <div className={classnames(classes.commentContents, classes.body2)}>
            {parsedCommentText.map((parsedText, index) => {
              return (
                <CommentString comment={parsedText} key={index} users={users} />
              );
            })}
            {truncateComment && (
              <span
                onClick={() => {
                  onViewSingleComment && onViewSingleComment(this.props.comment, {
                    users,
                    isAdmin,
                    editable,
                    onDelete
                  });
                }}
              >
                ...<span className={classes.readMore}>{t('Read more')}</span>
              </span>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

CommentItem.contextType = AppContext;
const translatedCommentItem = withNamespaces()(CommentItem);

export default withStyles(
  combineStyles(TypographyStyles, styles, SpacingStyles, LayoutStyles)
)(translatedCommentItem);
